import React, { useEffect, useRef, useState } from "react";
import {
  getNewHotspotSentence,
  getNewHotspotTopic,
  getNewHotspotVideo,
  getSentenceDetail,
} from "@/services/creativeScript/explosiveScript";
import EchartsReact from "echarts-for-react";
import dayjs from "dayjs";
import {
  top1,
  top2,
  top3,
  fx,
  jg,
  pl,
  rdz,
  sc,
  xzbf,
  hot_word,
  heart,
  video,
  copy,
  play,
  draft,
  classify,
  default_icon,
} from "@/assets/Inspiration-center";
import { IconDown, IconHeart } from "@arco-design/web-react/icon";
import { Message, Tooltip } from "@arco-design/web-react";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { copyText } from "@/utils/tool";
const getTop = (opt) => {
  let fontSize;
  if (opt < 99) {
    fontSize = 14;
  } else {
    fontSize = 10;
  }

  const actionItem = {
    1: <img src={top1} width={50} alt="" />,
    2: <img src={top2} width={50} alt="" />,
    3: <img src={top3} width={50} alt="" />,
  };
  return (
    actionItem[opt] || (
      <div className="top-number" style={{ fontSize }}>
        {opt}
      </div>
    )
  );
};
function formatNumber(num) {
  if (!num) {
    return 0;
  }
  if (num >= 100000000) {
    // 将数字除以100000000，获得亿为单位的数值
    let result = num / 100000000;

    // 保留小数点后两位
    result = Math.floor(result * 10) / 10;

    // 如果小数部分是 .00，则去掉小数
    if (result === Math.floor(result)) {
      result = Math.floor(result);
    }

    return result + "亿";
  } else if (num >= 10000) {
    // 将数字除以10000，获得万为单位的数值
    let result = num / 10000;

    // 保留小数点后两位
    result = Math.floor(result * 10) / 10;

    // 如果小数部分是 .00，则去掉小数
    if (result === Math.floor(result)) {
      result = Math.floor(result);
    }

    return result + "w";
  }

  return num.toString(); // 小于10000的数字直接返回字符串
}

function useData(tagActiveIndex) {
  const navigat = useNavigate();
  //   热门视频
  const [hotspotVideoSearch, setHotspotVideoSearch] = useState({
    billboard_tag: undefined,
    order_key: 1,
    time_filter: 3,
  });
  const [hotspotVideoList, setHotspotVideoList] = useState(null);
  const [hotspotTopicList, setHotspotTopicList] = useState(null);
  const [hotspotSentenceList, setHotspotSentenceList] = useState(null);
  const [hotspotVideoLoading, setHotspotVideoLoading] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [hotspotSentenceTotal, setHotspotSentenceTotal] = useState<number>(0);
  const [hotspotTopicTotal, setHotspotTopicTotal] = useState<number>(0);
  const [expandRow, setExpandRow] = useState([]);
  const handleNewHotspotVideo = async () => {
    setHotspotVideoLoading(true);
    const res = await getNewHotspotVideo(hotspotVideoSearch);
    setHotspotVideoLoading(false);
    if (res?.code == 0 && res.data?.items) {
      setHotspotTopicList(null);
      setHotspotSentenceList(null);
      setHotspotVideoList(
        res.data.items.map((v, i) => ({
          ...v,
          sort: i + 1,
        }))
      );
    } else {
      setHotspotVideoList([]);
    }
  };
  useEffect(() => {
    if (tagActiveIndex == 3) handleNewHotspotVideo();
  }, [hotspotVideoSearch, tagActiveIndex]);

  //   热门话题
  const [hotspotTopicSearch, setHotspotTopicSearch] = useState({
    page: 1,
    page_size: 10,
    date_window: 24,
    sub_type: 2001,
    tags: [],
  });

  const [hotspotTopicLoading, setHotspotTopicLoading] = useState(false);
  const handleNewHotspotTopic = async () => {
    setHotspotTopicLoading(true);
    const res = await getNewHotspotTopic(hotspotTopicSearch);
    setHotspotTopicLoading(false);

    if (res?.code == 0 && res.data?.items) {
      setHotspotSentenceList(null);
      setHotspotVideoList(null);
      setHotspotSentenceTotal(0);
      setHotspotTopicTotal(res.data?.total || 1000);
      setHotspotTopicList(
        res.data.items.map((v, i) => ({
          ...v,
          sort:
            i +
            1 +
            (hotspotTopicSearch.page - 1) * hotspotTopicSearch.page_size,
        }))
      );
    } else {
      setHotspotTopicList([]);
      setHotspotTopicTotal(0);
    }
  };
  useEffect(() => {
    if (tagActiveIndex == 1) handleNewHotspotTopic();
  }, [hotspotTopicSearch, tagActiveIndex]);

  // 热门热点
  const [hotspotSentenceSearch, setHotspotSentenceSearch] = useState({
    page: 1,
    page_size: 10,
    start_date: 20250208,
    end_date: Number(dayjs().format("YYYYMMDD")),
    snapshot_time: 0,
    sentence_tag: "",
    type: "range",
  });

  const [hotspotSentenceLoading, setHotspotSentenceLoading] = useState(false);

  const handleNewHotspotSentence = async () => {
    setHotspotSentenceLoading(true);
    const res = await getNewHotspotSentence(hotspotSentenceSearch);
    setHotspotSentenceLoading(false);

    if (res?.code == 0 && res.data?.item) {
      setHotspotVideoList(null);
      setHotspotTopicList(null);
      setHotspotSentenceTotal(res.data?.total || 0);
      setHotspotSentenceList(
        res.data.item.map((v, i) => ({
          ...v,
          sort:
            i +
            1 +
            (hotspotSentenceSearch.page - 1) * hotspotSentenceSearch.page_size,
        }))
      );
    } else {
      setHotspotSentenceTotal(0);
      setHotspotSentenceList([]);
    }
  };
  useEffect(() => {
    if (tagActiveIndex == 2) handleNewHotspotSentence();
    setExpandedRowKeys([]);
    setExpandRow([]);
  }, [hotspotSentenceSearch, tagActiveIndex]);
  const handleExpandRow = async (item) => {
    if (expandedRowKeys.includes(item.sort)) {
      // 当前行已经展开，点击时关闭它
      setExpandedRowKeys([]);
      setExpandRow([]);
    } else {
      // 展开当前行，并关闭其他行
      const res = await getSentenceDetail({
        sentence_id: `${item.sentence_id}`,
      });
      setExpandedRowKeys([item.sort]);
      if (res?.code == 0 && res.data.items) {
        setExpandRow(res.data.items);
      } else {
        setExpandRow([]);
      }
    }
  };
  const getColumns = () => {
    const actionItems = {
      3: [
        {
          title: (
            <div className="columns-header">
              <p>排名</p>
            </div>
          ),
          dataIndex: "sort",
          key: "0",
          width: 70,
          render: (_, item) => (
            <div className="expand-box">
              <div>{getTop(_)}</div>
            </div>
          ),
        },
        {
          title: (
            <div className="columns-header">
              <p>视频信息</p>
            </div>
          ),
          width: 450,
          dataIndex: "title",
          key: "1-1",
          render: (_, item) => (
            <div className="video-info">
              <div>
                <img
                  src={item.cover_url}
                  style={{ marginRight: 15 }}
                  width={44}
                  alt=""
                />
                <img
                  src={play}
                  width={23}
                  className="play"
                  alt=""
                  onClick={() => window.open(item.share_url, "_blank")}
                />
              </div>
              <div>
                <p className="video-title">{_}</p>
                <div className="video-author">
                  <img
                    width={20}
                    style={{ borderRadius: "50%" }}
                    src={item.head_img}
                    alt=""
                  />
                  <p>{item.nick_name}</p>
                </div>
              </div>
            </div>
          ),
        },
        {
          title: (
            <div className="columns-header">
              <img src={hot_word} alt="" />
              <p>热词</p>
            </div>
          ),
          dataIndex: "key_words",
          key: "1-2",
          render: (_) => (
            <div className="hot-info">
              <p className="hot-word">{_?.join("、")}</p>
            </div>
          ),
        },
        {
          title: (
            <div className="columns-header">
              <img src={rdz} alt="" />
              <p>热度</p>
            </div>
          ),

          width: 150,
          dataIndex: "hot_score",
          key: "1-3",
          render: (_) => <p>{formatNumber(_)}</p>,
        },
        {
          title: (
            <div className="columns-header">
              <img src={xzbf} alt="" />
              <p>播放</p>
            </div>
          ),
          width: 150,
          dataIndex: "play_count",
          key: "1-4",
          render: (_) => <p>{formatNumber(_)}</p>,
        },
        {
          title: (
            <div className="columns-header">
              <img src={heart} alt="" />
              <p>点赞</p>
            </div>
          ),
          width: 150,
          dataIndex: "like_count",
          key: "1-5",
          // (_ * 100).toFixed(2) + "%"
          render: (_) => <p>{formatNumber(_)}</p>,
        },

        {
          title: (
            <div className="columns-header">
              <img src={pl} alt="" />
              <p>评论</p>
            </div>
          ),
          width: 150,
          dataIndex: "comment_count",
          key: "1-6",
          render: (_) => <p>{formatNumber(_)}</p>,
        },

        // {
        //   title: (
        //     <div className="columns-header">
        //       <img src={sc} alt="" />
        //       <p>收藏</p>
        //     </div>
        //   ),
        //   dataIndex: "age",
        //   key: "1-7",
        // },
        {
          title: (
            <div className="columns-header">
              <img src={fx} alt="" />
              <p>分享</p>
            </div>
          ),
          width: 150,
          dataIndex: "share_count",
          key: "1-8",
          render: (_) => <p>{formatNumber(_)}</p>,
        },
        {
          title: (
            <div className="columns-header">
              <p>操作</p>
            </div>
          ),
          key: "1-9",
          width: 120,
          fixed: "right",
          render: (_, item) => (
            <div
              className="analysis-btn"
              onClick={() => {
                navigat(`/analysis-video`, { state: item.share_url });
              }}
            >
              <p>AI解析</p>
            </div>
          ),
        },
      ],
      2: [
        {
          title: (
            <div className="columns-header">
              <p>排名</p>
            </div>
          ),
          dataIndex: "sort",
          key: "0",
          width: 70,
          render: (_) => (
            <div className="expand-box">
              <div>{getTop(_)}</div>
            </div>
          ),
        },
        {
          title: (
            <div className="columns-header">
              <p>热点事件</p>
            </div>
          ),
          dataIndex: "sentence",
          key: "2-1",
          render: (_) => (
            <div className="hot-info">
              {/* <div className="img"></div> */}
              <p>{_}</p>
            </div>
          ),
        },
        {
          title: (
            <div className="columns-header">
              <p>热度趋势</p>
            </div>
          ),
          dataIndex: "trend",
          key: "3-2",
          render: (_, item, index) => (
            <div className="">
              <EchartsReact
                option={{
                  xAxis: {
                    type: "category",
                    data: _?.map((v) => v.datetime) || [],
                    show: false, // 不显示坐标轴线、坐标轴刻度线和坐标轴上的文字
                  },
                  yAxis: {
                    type: "value",
                    show: false,
                  },
                  series: [
                    {
                      data: _?.map((v) => v.hot_score) || [],
                      type: "line",
                      areaStyle: {
                        color: {
                          type: "linear",
                          x: 0,
                          y: 0,
                          x2: 0,
                          y2: 1,
                          colorStops: [
                            {
                              offset: 0,
                              color: "rgba(255, 127, 80, 1)", // color at 0% position
                            },
                            {
                              offset: 1,
                              color: "rgba(255, 127, 80, 0)", // color at 100% position
                            },
                          ],
                          global: false, // false by default
                        },
                      },
                      lineStyle: {
                        color: "#ff7f50",
                      },
                      symbol: "none", // 隐藏数据点
                    },
                  ],
                  tooltip: {
                    trigger: "axis",
                    position: (point, params, dom, rect, size) => {
                      // point 为鼠标位置的坐标数组 [x, y]
                      const x = point[0];
                      const y = point[1];
                      // 设置 tooltip 显示在鼠标下方
                      if (index === 0) {
                        // 如果 dataIndex 为 0，显示在鼠标下方
                        return [x, y + 20]; // 10 可以根据需要调整
                      } else {
                        // 否则显示在鼠标上方
                        return [x, y - 70]; // 10 可以根据需要调整
                      } // 10 可以根据需要调整，控制 tooltip 的上下位置
                    },
                  },
                  grid: {
                    left: "0%",
                    right: "0%",
                    bottom: "0%",
                    top: "0%",
                    containLabel: false,
                  },
                }}
                style={{ height: 50, width: 132 }}
              />
            </div>
          ),
        },
        {
          title: (
            <div className="columns-header">
              <img src={rdz} alt="" />
              <p>热度</p>
            </div>
          ),
          dataIndex: "hot_score",
          key: "2-2",
          render: (_) => <p>{formatNumber(_)}</p>,
        },

        // {
        //   title: (
        //     <div className="columns-header">
        //       <img src={rdz} alt="" />
        //       <p>关联视频数量</p>
        //     </div>
        //   ),
        //   width: 150,

        //   dataIndex: "video_count",
        //   key: "2-3",
        //   render: (_) => <p>{formatNumber(_)}</p>,
        // },
        {
          title: (
            <div className="columns-header">
              <img src={classify} alt="" />
              <p>所属分类</p>
            </div>
          ),
          dataIndex: "sentence_tag_name",
          key: "2-4",
          render: (_) => <p>{_}</p>,
        },
        {
          title: (
            <div className="columns-header">
              <p>操作</p>
            </div>
          ),
          key: "2-8",
          width: 150,

          dataIndex: "sentence_id",
          fixed: "right",
          render: (_, item) => (
            <div
              className="analysis-btn"
              onClick={debounce(() => {
                handleExpandRow(item);
              }, 500)}
            >
              <p>查看详情</p>
            </div>
          ),
        },
      ],
      1: [
        {
          title: (
            <div className="columns-header">
              <p>排名</p>
            </div>
          ),
          dataIndex: "sort",
          key: "0",
          width: 70,
          render: (_, item) => (
            <div className="expand-box">
              <div>{getTop(_)}</div>
            </div>
          ),
        },
        {
          title: (
            <div className="columns-header">
              <p>话题名称</p>
            </div>
          ),
          dataIndex: "challenge_name",
          key: "3-1",
          width: 360,
          render: (_, item) => (
            <div className="topic-name-box">
              <img
                src={item.cover_url || default_icon}
                width={44}
                style={{ marginRight: 15 }}
                alt=""
              />

              <div>
                <p className="topic-name-text">{_}</p>
                <div
                  className="topic-name-copy"
                  onClick={() => {
                    try {
                      // navigator.clipboard.writeText(_);
                      copyText(_);
                      Message.success("复制成功");
                    } catch (error) {
                      Message.success("复制失败");
                    }
                  }}
                >
                  <img src={copy} width={14} alt="" />
                  <p>复制</p>
                </div>
              </div>
            </div>
          ),
        },
        {
          title: (
            <div className="columns-header">
              <p>热度趋势</p>
            </div>
          ),
          dataIndex: "trends",
          key: "3-2",
          width: 200,
          render: (_, item, index) => (
            <div className="">
              <EchartsReact
                option={{
                  xAxis: {
                    type: "category",
                    data: _?.map((v) => v.date) || [],
                    show: false, // 不显示坐标轴线、坐标轴刻度线和坐标轴上的文字
                  },
                  yAxis: {
                    type: "value",
                    show: false,
                  },
                  series: [
                    {
                      data: _?.map((v) => v.value) || [],
                      type: "line",
                      areaStyle: {
                        color: {
                          type: "linear",
                          x: 0,
                          y: 0,
                          x2: 0,
                          y2: 1,
                          colorStops: [
                            {
                              offset: 0,
                              color: "rgba(255, 127, 80, 1)", // color at 0% position
                            },
                            {
                              offset: 1,
                              color: "rgba(255, 127, 80, 0)", // color at 100% position
                            },
                          ],
                          global: false, // false by default
                        },
                      },
                      lineStyle: {
                        color: "#ff7f50",
                      },
                      symbol: "none", // 隐藏数据点
                    },
                  ],
                  tooltip: {
                    trigger: "axis",
                    position: (point, params, dom, rect, size) => {
                      // point 为鼠标位置的坐标数组 [x, y]
                      const x = point[0];
                      const y = point[1];
                      // 设置 tooltip 显示在鼠标下方
                      if (index === 0) {
                        // 如果 dataIndex 为 0，显示在鼠标下方
                        return [x, y + 20]; // 10 可以根据需要调整
                      } else {
                        // 否则显示在鼠标上方
                        return [x, y - 70]; // 10 可以根据需要调整
                      } // 10 可以根据需要调整，控制 tooltip 的上下位置
                    },
                  },
                  grid: {
                    left: "0%",
                    right: "0%",
                    bottom: "0%",
                    top: "0%",
                    containLabel: false,
                  },
                }}
                style={{ height: 50, width: 132 }}
              />
            </div>
          ),
        },
        {
          title: (
            <div className="columns-header">
              <img src={rdz} alt="" />
              <p>热度值</p>
              {/* <Tooltip content="根据时间周期内新增的投稿、播放、点赞、评论、分享等指标加权计算">
                <img src={jg} alt="" />
              </Tooltip> */}
            </div>
          ),
          dataIndex: "score",
          render: (_) => <p>{formatNumber(_)}</p>,
          key: "3-3",
        },
        {
          title: (
            <div className="columns-header">
              <img src={video} alt="" />
              <p>视频量</p>
              {/* <Tooltip content="话题的累计投稿量">
                <img src={jg} alt="" />
              </Tooltip> */}
            </div>
          ),
          dataIndex: "publish_cnt",
          key: "3-4",
          render: (_) => <p>{formatNumber(_)}</p>,
        },
        {
          title: (
            <div className="columns-header">
              <img src={xzbf} alt="" />
              <p>播放量</p>
              {/* <Tooltip content="话题的累计播放量">
                <img src={jg} alt="" />
              </Tooltip> */}
            </div>
          ),
          dataIndex: "play_cnt",
          key: "3-5",
          render: (_) => <p>{formatNumber(_)}</p>,
        },
        {
          title: (
            <div className="columns-header">
              <img src={draft} alt="" />
              <p>稿均播放量</p>
              {/* <Tooltip content="播放量/视频量，表示参与话题投稿视频的播放量均值">
                <img src={jg} alt="" />
              </Tooltip> */}
            </div>
          ),
          dataIndex: "avg_play_cnt",
          key: "3-6",
          render: (_) => <p>{formatNumber(_)}</p>,
        },

        // {
        //   title: (
        //     <div className="columns-header">
        //       <p>操作</p>
        //     </div>
        //   ),
        //   key: "3-7",
        //   render: (_, item) => (
        //     <div className="analysis-btn">
        //       <p>查看详情</p>
        //     </div>
        //   ),
        // },
      ],
    };
    return actionItems[tagActiveIndex];
  };
  const heightOptions = [
    {
      label: "播放最高",
      value: 1,
    },
    {
      label: "点赞最多",
      value: 2,
    },
    {
      label: "评论最多",
      value: 3,
    },
    {
      label: "热度最高",
      value: 4,
    },
  ];
  const timeOptions = [
    {
      label: "24小时",
      value: 1,
    },
    {
      label: "7天",
      value: 2,
    },
    {
      label: "30天",
      value: 3,
    },
  ];

  const isContinuousScrollingRef = useRef(false);
  const [currentDirection, setCurrentDirection] = useState(0); // 当前滚动方向
  const [isAtLeft, setIsAtLeft] = useState(true); // 是否已经滚动到最左边
  const [isAtRight, setIsAtRight] = useState(false); // 是否已经滚动到最右边
  const contentWrapperRef = useRef(null);
  const scrollAmount = 160; // 每次滚动的距离
  const continuousScrollSpeed = 10; // 连续滚动时的速度
  const scrollTimeoutRef = useRef(null); // 用于存储定时器
  const [startTimer, setStartTimer] = useState(null);
  const [timeDifference, setTimeDifference] = useState(0);
  const [isDragging, setIsDragging] = useState(false); // 是否正在拖拽
  const [startX, setStartX] = useState(0); // 鼠标按下时的起始位置
  const [scrollStart, setScrollStart] = useState(0); // 滚动容器的起始位置

  // 更新按钮的显隐
  const updateButtonVisibility = () => {
    const contentWrapper = contentWrapperRef.current;
    const atLeft = contentWrapper.scrollLeft === 0;
    const atRight =
      contentWrapper.scrollLeft ===
      contentWrapper.scrollWidth - contentWrapper.clientWidth;

    setIsAtLeft(atLeft);
    setIsAtRight(atRight);
  };

  // 离散滚动（短按）
  const discreteScroll = (direction) => {
    if (contentWrapperRef.current) {
      contentWrapperRef.current.scrollBy({
        left: direction * scrollAmount,
        behavior: "smooth",
      });
    }
  };

  // 连续滚动（长按）
  const continuousScroll = (direction) => {
    if (isContinuousScrollingRef.current && contentWrapperRef.current) {
      contentWrapperRef.current.scrollLeft += direction * continuousScrollSpeed;
      requestAnimationFrame(() => continuousScroll(direction));
    }
  };

  const handleMouseDown = (direction) => {
    setCurrentDirection(direction);

    // 设置定时器，200ms 后认为是长按
    scrollTimeoutRef.current = setTimeout(() => {
      // setIsContinuousScrolling(true);
      isContinuousScrollingRef.current = true;
      continuousScroll(direction);
    }, 200);
  };

  const handleMouseUpOrLeave = () => {
    // 清理定时器
    const nowTimer = new Date().getTime();
    if (timeDifference !== 301.1) {
      setTimeDifference(nowTimer - startTimer);
    }

    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = null;
      // 如果长按未触发，则执行一次离散滚动
      if (!isContinuousScrollingRef.current) {
        discreteScroll(currentDirection);
      }
    }
    isContinuousScrollingRef.current = false;
    setIsDragging(false); // 释放拖拽状态

    // 恢复可选内容
    if (contentWrapperRef.current) {
      contentWrapperRef.current.style.userSelect = "auto";
    }
  };

  // 鼠标拖动事件
  const handleMouseMove = (e) => {
    if (!isDragging) return;

    const deltaX = e.clientX - startX; // 计算鼠标水平移动距离
    if (contentWrapperRef.current) {
      contentWrapperRef.current.scrollLeft = scrollStart - deltaX; // 更新滚动位置
      contentWrapperRef.current.style.cursor = "grabbing";
      setTimeDifference(301.1);
    }
  };

  const handleMouseDownDrag = (e) => {
    setStartTimer(new Date().getTime());
    setTimeDifference(0);
    setIsDragging(true);
    setStartX(e.clientX); // 记录鼠标按下时的位置
    setScrollStart(contentWrapperRef.current.scrollLeft); // 记录当前滚动位置

    // 禁止文本选择
    if (contentWrapperRef.current) {
      contentWrapperRef.current.style.userSelect = "none";
    }
  };
  // 监听滚动事件
  useEffect(() => {
    const contentWrapper = contentWrapperRef.current;
    if (!contentWrapper) return;
    const handleScroll = () => {
      updateButtonVisibility();
    };

    contentWrapper.addEventListener("scroll", handleScroll);

    // 初始化时检查按钮显示状态
    updateButtonVisibility();

    // 清理监听器
    return () => {
      contentWrapper.removeEventListener("scroll", handleScroll);
    };
  }, [expandedRowKeys]);

  return {
    hotspotVideoList,
    hotspotVideoLoading,
    hotspotVideoSearch,
    setHotspotVideoSearch,

    hotspotTopicList,
    hotspotTopicLoading,
    hotspotTopicSearch,
    setHotspotTopicSearch,

    hotspotSentenceList,
    hotspotSentenceLoading,
    hotspotSentenceSearch,
    setHotspotSentenceSearch,
    getColumns,
    timeOptions,
    heightOptions,
    expandedRowKeys,
    expandRow,
    isAtLeft,
    isAtRight,
    handleMouseDown,
    handleMouseUpOrLeave,
    contentWrapperRef,
    hotspotSentenceTotal,
    hotspotTopicTotal,
    handleMouseMove,
    handleMouseDownDrag,
    timeDifference,
  };
}

export default useData;
